import { MyScenariosPage } from '@/app/pages/profile/my-scenarios-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/scenarios')({
  component: MyScenariosPage,
});
